import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { AnnualImpactReportService, AnnualImpactReport } from '../../../../services/annual-impact-report.service';
import { CentreService } from '../../../../services/centre.service';
import { Centre } from '../../../../interfaces/Centres';

@Component({
  selector: 'app-annual-impact-report-table',
  templateUrl: './annual-impact-report-table.component.html',
  styleUrls: ['./annual-impact-report-table.component.scss'],
})
export class AnnualImpactReportTableComponent implements OnInit, OnDestroy {
  centres$: Observable<Centre[]>;
  reports: AnnualImpactReport[] = [];
  selectedCentre = '';
  loading = false;

  displayedColumns = ['centreName', 'donorName', 'financialYear', 'submitType', 'createdAt', 'actions'];

  private subs = new SubSink();

  constructor(
    private reportService: AnnualImpactReportService,
    private centreService: CentreService,
    private router: Router,
  ) {
    this.centres$ = this.centreService.getAllCentres();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loadReports(): void {
    if (!this.selectedCentre) return;
    this.loading = true;
    this.subs.add(
      this.reportService.getReports(this.selectedCentre).subscribe(reports => {
        this.reports = reports;
        this.loading = false;
      })
    );
  }

  createNew(): void {
    this.router.navigate(['reports/annual-impact-report']);
  }
}
